import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import { ContactPage } from './contact.page';

import { BrowserFooterComponentModule } from '../../shared/components/browser-footer/browser-footer.module';
import { BrowserHeaderComponentModule } from '../../shared/components/browser-header/browser-header.module';

import { ContactPageRoutingModule } from './contact-routing.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    ContactPageRoutingModule,
    TranslateModule.forChild(),
    BrowserHeaderComponentModule,
    BrowserFooterComponentModule,
  ],
  declarations: [ContactPage],
})
export class ContactPageModule {}
